import { getLoaderRequest, patchLoaderRequest, putLoaderRequest } from '@/services/requests'

export const profile = getLoaderRequest('/v1/user/profile')
export const changeLanguage = patchLoaderRequest('/v1/user/change-language')
export const favoriteProducts = getLoaderRequest('/v1/products/favorite')
export const updateProfile = patchLoaderRequest('/v1/user/profile/update')
export const additionalInfo = getLoaderRequest('/v1/user/additional-info')
export const updateAdditionalInfo = putLoaderRequest('/v1/user/additional-info/update')
export const updateUserCity = patchLoaderRequest('/v1/user/city')
